// CategoryCarouselNoSwiper.js
import { useState, useContext } from "react";
import {
  TrendingUp,
  Link2,
  Target,
  Star,
  Users,
  Globe,
  Rocket,
  Lightbulb,
  BarChart2,
  ChevronUp,
  Handshake,
  BadgeDollarSign,
} from "lucide-react";
import Popup from "./Popup";
import "./CategoryCarouselNoSwiper.css";
import { ThemeContext } from "../context/themeContext";

const baseCategories = [
  { id: 1, title: "Investor",    icon: <TrendingUp size={17} />,      color: "#C1440E" },
  { id: 2, title: "B2B",         icon: <Link2 size={17} />,           color: "#3B82F6" },
  { id: 3, title: "GTM",         icon: <Target size={17} />,          color: "#10B981" },
  { id: 4, title: "Membership",  icon: <Star size={17} />,            color: "#8B5CF6" },
  { id: 5, title: "Match",       icon: <Users size={17} />,           color: "#F59E0B" },
  { id: 6, title: "Community",   icon: <Globe size={17} />,           color: "#06B6D4" },
  { id: 7, title: "Startup",     icon: <Rocket size={17} />,          color: "#EC4899" },
  { id: 8, title: "Innovation",  icon: <Lightbulb size={17} />,       color: "#84CC16" },
  { id: 9, title: "Reports",     icon: <BarChart2 size={17} />,       color: "#6366F1" },
];

const extraCategories = [
  { id: 10, title: "Revenue",    icon: <BadgeDollarSign size={17} />, color: "#F97316" },
  { id: 11, title: "Funding",    icon: <Handshake size={17} />,       color: "#14B8A6" },
];

function chipStyle(color) {
  return {
    background: `linear-gradient(145deg, ${color}48 0%, ${color}1c 60%, ${color}32 100%)`,
    border: `1.5px solid ${color}66`,
    color: color,
    boxShadow: `0 4px 14px ${color}2e, inset 0 1.5px 0 rgba(255,255,255,0.62), inset 0 -1px 0 ${color}22`,
  };
}

export default function CategoryCarouselNoSwiper({ setToggle, onClose }) {
  const [active, setActive] = useState(null);
  const [showMore, setShowMore] = useState(false);
  const { activeTheme } = useContext(ThemeContext);
  const [selectedCategory, setSelectedCategory] = useState(null);

  const handleCategoryClick = (cat) => {
    setActive(cat.title);
    setSelectedCategory(cat);
  };

  return (
    <div className={`cc-wrapper ${activeTheme === "dark" ? "dark-mode" : ""}`}>
      <div className="cc-scroll-row" role="list">
        {baseCategories.map((cat) => (
          <button
            key={cat.id}
            className={`cc-item ${cat.title.toLowerCase()} ${active === cat.title ? "active" : ""}`}
            onClick={() => handleCategoryClick(cat)}
            aria-pressed={active === cat.title}
          >
            <div className="cc-circle" style={chipStyle(cat.color)}>
              {cat.icon}
            </div>
            <div className="cc-label">{cat.title}</div>
          </button>
        ))}

        {showMore &&
          extraCategories.map((cat) => (
            <button
              key={cat.id}
              className={`cc-item ${cat.title.toLowerCase()} ${active === cat.title ? "active" : ""}`}
              onClick={() => handleCategoryClick(cat)}
              aria-pressed={active === cat.title}
            >
              <div className="cc-circle" style={chipStyle(cat.color)}>
                {cat.icon}
              </div>
              <div className="cc-label">{cat.title}</div>
            </button>
          ))}

        <button
          className={`cc-item more ${active === "More" ? "active" : ""}`}
          onClick={() => {
            setShowMore(!showMore);
            setActive("More");
          }}
        >
          <div className="cc-circle more-circle">
            {showMore ? (
              <ChevronUp size={16} />
            ) : (
              <div className="dot-wrapper">
                <span className="dot"></span>
                <span className="dot"></span>
                <span className="dot"></span>
              </div>
            )}
          </div>
          <div className="cc-label">{showMore ? "Show Less" : "More"}</div>
        </button>
      </div>

      <div className="popup">
        <Popup
          show={!!selectedCategory}
          onClose={() => setSelectedCategory(null)}
          category={selectedCategory}
        />
      </div>
    </div>
  );
}
